import './js/modal';

import './js/header/header-mobile';
import './js/header/headerSearchByName';
import { renderFavoriteCocktailsMarkup } from './js/createFavoritesPage';

renderFavoriteCocktailsMarkup();
